'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$28() {
  this.bhp = null;
  this.bhn = null;
  this.bho = false;
  this.bhl = null;
  this.bhm = false;
  this.bhq = false;
  this.bhr = false;
  this.bhp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$28 as $c_Lpresto_PrestoRouter$$anon$28 };
$p = $c_Lpresto_PrestoRouter$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$28;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$28() {
}
export { $h_Lpresto_PrestoRouter$$anon$28 as $h_Lpresto_PrestoRouter$$anon$28 };
$h_Lpresto_PrestoRouter$$anon$28.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bhp;
});
$p.t = (function() {
  if ((!this.bho)) {
    this.bhn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bho = true;
  }
  return this.bhn;
});
$p.ag = (function() {
  if ((!this.bhm)) {
    this.bhl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhm = true;
  }
  return this.bhl;
});
$p.v = (function() {
  if ((!this.bhr)) {
    this.bhq = false;
    this.bhr = true;
  }
  return this.bhq;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$28, "presto.PrestoRouter$$anon$28", ({
  O1: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$28 as $d_Lpresto_PrestoRouter$$anon$28 };
//# sourceMappingURL=presto.-Presto-Router$$anon$28.js.map
